import can from './can'

const install = function (Vue) {
    Vue.directive('can', can)
};

if (window.Vue) {
    window['can'] = can;
    Vue.use(install); // eslint-disable-line
}

can.install = install;
export default can;
